
const collect = resolve => require(['@/components/order/collect'],resolve);
const myorder = resolve => require(['@/components/order/myorder'],resolve);
const unusualOrder = resolve => require(['@/components/order/unusualOrder'],resolve);
const rank = resolve => require(['@/components/order/rank'],resolve);
const audit = resolve => require(['@/components/order/audit'],resolve);
const auditDetail = resolve => require(['@/components/order/auditDetail'],resolve);
const minimumOrder = resolve => require(['@/components/order/minimumOrder'],resolve);
const analyze = resolve => require(['@/components/order/analyzeIndex'],resolve);
const retailOrderAnalyse = resolve => require(['@/components/order/retailOrderAnalyse/index'],resolve);
const target = resolve => require(['@/components/order/target'],resolve);
const newPlan = resolve => require(['@/components/order/newPlan'],resolve);
const planDetail = resolve => require(['@/components/order/planDetail'],resolve);
const productTotal = resolve => require(['@/components/order/productTotal'],resolve);
const colorSizeRatio = resolve => require(['@/components/order/colorSizeRatio'],resolve);
const productsLimitDetail = resolve => require(['@/components/order/productsLimitDetail'],resolve);
const productsOrderLimitDetail = resolve => require(['@/components/order/productsOrderLimitDetail'],resolve);
export default [
	{
		path : 'order/collect',
		name : 'orderCollect',
		meta : {
			title : '收藏评款',
			searchDisabled : true
		},
		component : collect
	},
	{
		path : 'order/myorder',
		name : 'orderMyOrder',
		meta : {
			title : '我的订单',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : myorder
	},
	{
		path : 'order/unusual',
		name : 'orderUnusual',
		meta : {
			title : '异常订单',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : unusualOrder
	},
	{
		path : 'order/rank',
		name : 'orderRank',
		meta : {
			title : '订货排名',
			searchDisabled : false,
			notNeedGlobalScroll : true
		},
		component : rank
	},
	{
		path : 'order/audit',
		name : 'orderAudit',
		meta : {
			title : '订单审核',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : audit
	},
	{
		path : 'order/auditDetail',
		name : 'orderAuditDetail',
		meta : {
			title : '订单审核',
			searchDisabled : true,
			activeName : 'orderAudit',
			notNeedGlobalScroll : true
		},
		component : auditDetail
	},
	{
		path : 'order/minimumOrder',
		name : 'orderMinimumOrder',
		meta : {
			title : '起订量',
			searchDisabled : true,
			activeName : 'minimumOrder',
			notNeedGlobalScroll : true
		},
		component : minimumOrder
	},
	{
		path : 'order/analyze',
		name : 'orderAnalyze',
		meta : {
			title : '订单分析',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : analyze
	},
	{
		path : 'order/retailOrderAnalyse/index',
		name : 'retailOrderAnalyze',
		meta : {
			title : '零售订单分析',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : retailOrderAnalyse
	},
	{
		path : 'order/target',
		name : 'orderTarget',
		meta : {
			title : '指标达成',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : target
	},
	{
		path : 'order/newPlan',
		name : 'orderNewPlan',
		meta : {
			title : '新订货规划',
			searchDisabled : true,
			notNeedGlobalScroll : true,
		},
		component : newPlan
	},
	{
		path : 'order/planDetail',
		name : 'orderPlanDetail',
		meta : {
			title : '新订货规划明细',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : planDetail
	},
	{
		path : 'order/productTotal',
		name : 'orderProductTotal',
		meta : {
			title : '订量汇总',
			searchDisabled : false,
			notNeedGlobalScroll : true
		},
		component : productTotal
	},
	{
		path : 'order/colorSizeRatio',
		name : 'orderColorSizeRatio',
		meta : {
			title : '款色尺码占比',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : colorSizeRatio
	},
	{
		path : 'order/productsLimitDetail',
		name : 'productsLimitDetail',
		meta : {
			title : '商品组限制详情',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : productsLimitDetail
	},
	{
		path : 'order/productsOrderLimitDetail',
		name : 'productsOrderLimitDetail',
		meta : {
			title : '组合起订量详情',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : productsOrderLimitDetail
	},
]



// WEBPACK FOOTER //
// ./src/router/order/index.js